import React from 'react';
import { Container, makeStyles } from '@material-ui/core';
import Logo from './Logo';

const useStyles = makeStyles(() => ({
    topBar: {
        paddingTop: "30px",
    },
    container: {
        display: "flex",
        justifyContent: "space-between"
    }
}));

const TopBar = () => {
    const classes = useStyles();

    return (
        <div className={classes.topBar}>
            <Container className={classes.container}>
                <Logo />
            </Container>
        </div>
    )
}
export default TopBar;